"use client";

import { useEffect, useState } from "react";

interface RankMathSchemaProps {
  jsonLd: string;
}

export default function RankMathSchema({ jsonLd }: RankMathSchemaProps) {
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    setHtml(jsonLd);
  }, [jsonLd]);

  if (!html) return null;

  return <div dangerouslySetInnerHTML={{ __html: jsonLd }} />;
}
